import React, { useEffect, useState } from "react";
import Aside from "../components/Aside";

import {
    Box,
    Container,
    Paper,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Stack,
    useMediaQuery,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import { useTheme } from "@mui/material/styles";

import { database } from "../services/firebase";
import { ref, onValue } from "firebase/database";

import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

// ==============================
// CONSTANTES DE LAYOUT (IGUAL DASHBOARD)
// ==============================
const ASIDE_W = 260;
const MOBILE_TOPBAR_H = 64;

const CARD_STYLE = {
    border: "1px solid rgba(0,0,0,0.08)",
    borderRadius: 4,
    background: "#fff",
    boxShadow: "0px 4px 20px rgba(0,0,0,0.03)",
    overflow: "hidden",
};

export default function Mensagens() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [messages, setMessages] = useState([]);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        const messagesRef = ref(database, "messages");

        const unsubscribe = onValue(messagesRef, (snapshot) => {
            if (!snapshot.exists()) {
                setMessages([]);
                return;
            }

            const data = snapshot.val();

            const parsed = Object.entries(data)
                .map(([id, value]) => ({
                    id,
                    ...value,
                }))
                .sort((a, b) => b.createdAt - a.createdAt);

            setMessages(parsed);
        });

        return () => unsubscribe();
    }, []);

    return (
        <>
            <Aside />

            <Box
                component="main"
                sx={{
                    minHeight: "100vh",
                    background: "var(--offwhite)",
                    ml: isMobile ? 0 : `${ASIDE_W}px`,
                    pt: isMobile ? `${MOBILE_TOPBAR_H + 24}px` : 4,
                    pb: 6,
                    px: { xs: 2, md: 4 },
                }}
            >
                <Container maxWidth="xl" disableGutters>
                    {/* HEADER */}
                    <Box sx={{ mb: 4 }}>
                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 900,
                                color: "var(--azulEscuro)",
                                letterSpacing: -1,
                                textAlign: "left",
                            }}
                        >
                            Mensagens
                        </Typography>
                        <Typography sx={{ color: "var(--text-muted)", fontWeight: 500, textAlign: "left" }}>
                            Mensagens enviadas pelo formulário de contato.
                        </Typography>
                    </Box>

                    {/* CARD TABELA */}
                    <Paper sx={CARD_STYLE}>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ bgcolor: "#fafafa" }}>
                                    {["Nome", "Email", "Assunto", "Data", "Ações"].map((h) => (
                                        <TableCell
                                            key={h}
                                            align={h === "Ações" ? "center" : "left"}
                                            sx={{
                                                fontWeight: 800,
                                                color: "var(--text-muted)",
                                                textTransform: "uppercase",
                                                fontSize: "0.75rem",
                                                letterSpacing: 0.5,
                                            }}
                                        >
                                            {h}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {messages.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                                            <Typography
                                                sx={{ color: "var(--text-muted)", fontWeight: 600 }}
                                            >
                                                Nenhuma mensagem recebida.
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}

                                {messages.map((msg) => (
                                    <TableRow key={msg.id} hover>
                                        <TableCell sx={{ fontWeight: 700, color: "var(--azulEscuro)" }}>
                                            {msg.nome}
                                        </TableCell>
                                        <TableCell sx={{ color: "var(--cinza)" }}>
                                            {msg.email}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>
                                            {msg.assunto}
                                        </TableCell>
                                        <TableCell sx={{ color: "var(--cinza)" }}>
                                            {format(new Date(msg.createdAt), "dd/MM/yyyy HH:mm", {
                                                locale: ptBR,
                                            })}
                                        </TableCell>
                                        <TableCell align="center">
                                            <IconButton onClick={() => setSelected(msg)}>
                                                <VisibilityIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Paper>
                </Container>
            </Box>

            {/* =======================
          DIALOG DETALHES
      ======================= */}
            <Dialog
                open={Boolean(selected)}
                onClose={() => setSelected(null)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 900, color: "var(--azulEscuro)" }}>
                    Mensagem de Contato
                </DialogTitle>

                <DialogContent dividers>
                    {selected && (
                        <Stack spacing={2}>
                            <Typography>
                                <b>Nome:</b> {selected.nome}
                            </Typography>
                            <Typography>
                                <b>Email:</b> {selected.email}
                            </Typography>
                            <Typography>
                                <b>Assunto:</b> {selected.assunto}
                            </Typography>
                            <Typography sx={{ whiteSpace: "pre-line" }}>
                                <b>Mensagem:</b><br />
                                {selected.mensagem}
                            </Typography>
                        </Stack>
                    )}
                </DialogContent>

                <DialogActions sx={{ p: 2 }}>
                    <Button
                        onClick={() => setSelected(null)}
                        variant="outlined"
                        sx={{ borderRadius: 2, fontWeight: 700 }}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}